// extracted by mini-css-extract-plugin
export default {"recommendations":"RecommendationList_recommendations__anbjX","recommendation":"RecommendationList_recommendation__Z3JnS"};